import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { ScheduleSlot } from '~/types/schedule'

interface SliceState {
  selectedTimeslotSchedules: ScheduleSlot[]
}

const initialState: SliceState = {
  selectedTimeslotSchedules: [],
}

const slice = createSlice({
  name: 'admin-schedule',
  initialState,
  reducers: {
    clearSelectedTimeslotSchedules: (state) => ({
      ...state,
      selectedTimeslotSchedules: [],
    }),

    setSelectedTimeslotSchedules: (state, action: PayloadAction<SliceState['selectedTimeslotSchedules']>) => ({
      ...state,
      selectedTimeslotSchedules: action.payload,
    }),
  },
})

export const selectSelectedTimeslotSchedules = (state: RootState): SliceState['selectedTimeslotSchedules'] => {
  return state.adminSchedule.selectedTimeslotSchedules
}

export const {
  clearSelectedTimeslotSchedules: clearSelectedTimeslotSchedulesActionCreator,
  setSelectedTimeslotSchedules: setSelectedTimeslotSchedulesActionCreator,
} = slice.actions

export default slice.reducer
